import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  gap: 18px;
`;

export const DeviceInfo = styled.div``;

export const DeviceStatusArea = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const DeviceName = styled.span`
  display: inline-block;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #ffffff;
`;

export const DeviceControlArea = styled.div`
  display: flex;
  margin-top: 8px;
`;

export const DeviceSplitArea = styled.div`
  display: flex;
  gap: 18px;
`;

export const DeviceSplitLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 70%;
`;

export const DeviceSplitRight = styled.div`
  display: flex;
  gap: 4px;
  width: 30%;
  aspect-ratio: 4/3;
`;
